module.exports = __webpack_public_path__ + "img/logo-brink.47be9c26.png";